// src/pages/About.js
import React from "react";
export default function About() {
  return (
    <div className="page-pad content-page">
      <h1>Nuestra historia</h1>
      <div className="about-grid">
        <div className="about-text">
          <p className="lead">Somos una empresa colombiana apasionada por el diseño y la tecnología de impresión 3D, creando piezas únicas con corazón.</p>
          <p>Cada pieza que sale de nuestros talleres es el resultado de un proceso cuidadoso de diseño digital, impresión capa por capa, y acabados artesanales. Usamos materiales ecológicos de alta calidad para garantizar durabilidad y conciencia ambiental.</p>
          <p>Nuestro objetivo es llevar a cada hogar y evento un poco de la creatividad colombiana, con precios justos y envío a todo el país.</p>
          <div className="about-values">
            {[
              { icon: "♥", title: "Amor por el detalle", desc: "Cada pieza es revisada manualmente antes de enviarse." },
              { icon: "🌱", title: "Materiales ecológicos", desc: "Usamos PLA biodegradable y tintas seguras." },
              { icon: "🇨🇴", title: "100% colombiano", desc: "Diseñado y producido en Colombia con orgullo." }
            ].map(v => (
              <div key={v.title} className="value-card">
                <span>{v.icon}</span>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
